var cupMap = new Map();
/**
 * Register Cup into cupMap
 * @param cup A Cup
 */
export function regCup(cup) {
    cupMap.set(cup.name, cup);
}
export function getAllCup() {
    return cupMap;
}
export function findCup(cupName) {
    var _a;
    return (_a = cupMap.get(cupName)) !== null && _a !== void 0 ? _a : null;
}
